import { UIText1 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './ChatHiddenPhone.css';

type TProps = {
  phone: string;
  onClick: () => void;
};

export const ChatHiddenPhone: React.FC<TProps> = ({ phone, onClick }) => {
  return (
    <button className={classNames(styles['button'])} onClick={onClick}>
      <UIText1 display="inline" color="primary_100">
        {phone}
      </UIText1>
    </button>
  );
};
